module.exports = __webpack_public_path__ + "img/Islem_Rekik@2x.e7d13b27.png";